export const GET_THIRD_PARTY_LICENSE_HAYNES = 'GET_THIRD_PARTY_LICENSE_HAYNES'
export const GET_THIRD_PARTY_LICENSE_HAYNES_SUCCESS = 'GET_THIRD_PARTY_LICENSE_HAYNES_SUCCESS'
export const GET_THIRD_PARTY_LICENSE_HAYNES_FAILED = 'GET_THIRD_PARTY_LICENSE_HAYNES_FAILED'
